<template>
  <v-card class="py-5" style="height: 100%; border-radius: 20px;">
    <v-card-title class="justify-center">Professional Skills</v-card-title>
    <v-card-text>
      <v-container fill-height>
        <v-row class="ma-0 pa-0 mt-5 body-1 font-weight-medium">
          <v-col cols="6">
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-progress-circular
                  color="rgba(112,123,255)"
                  size="100"
                  width="6"
                  :value="skills.communication"
                  rotate="-90"
                >
                  <span class="grey--text text--darken-1"
                    >{{ skills.communication }}%</span
                  >
                </v-progress-circular>
              </v-col>
              <v-col cols="12">
                Communication
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-progress-circular
                  color="rgba(112,123,255)"
                  size="100"
                  width="6"
                  :value="skills.creativity"
                  rotate="-90"
                >
                  <span class="grey--text text--darken-1"
                    >{{ skills.creativity }}%</span
                  >
                </v-progress-circular>
              </v-col>
              <v-col cols="12">
                Creativity
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-progress-circular
                  color="rgba(112,123,255)"
                  size="100"
                  width="6"
                  :value="skills.teamwork"
                  rotate="-90"
                >
                  <span class="grey--text text--darken-1"
                    >{{ skills.teamwork }}%</span
                  >
                </v-progress-circular>
              </v-col>
              <v-col cols="12">
                Teamwork
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-progress-circular
                  color="rgba(112,123,255)"
                  size="100"
                  width="6"
                  :value="skills.organisation"
                  rotate="-90"
                >
                  <span class="grey--text text--darken-1"
                    >{{ skills.organisation }}%</span
                  >
                </v-progress-circular>
              </v-col>
              <v-col cols="12">
                Organisation
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => {
    return {
      skills: {
        communication: 100,
        creativity: 100,
        teamwork: 90,
        organisation: 90
      }
    };
  }
};
</script>

<style></style>
